import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/styles.css';
import '../styles/nav.css';
import { getCompanies, postPatient } from '../services/api';
import { toast } from 'react-toastify';
import PasswordInput from './PasswordInput';
import { validatePassword } from '../utils/password';
import { formatRut } from '../utils/rut';
import {formatPhone}from '../utils/phone';


const CrearPaciente = () => {
  const [empresas, setEmpresas] = useState([]);
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    password: '',
    rut: '',
    apellido_p: '',
    apellido_m: '',
    fecha_nac: '',
    direccion: '',
    telefono: '',
    id_empresa: '',
    sexo: '',
    genero: '',
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmpresas = async () => {
      try {
        const { data } = await getCompanies();
        setEmpresas(data);
      } catch (error) {
        console.error('Error al obtener empresas:', error);
        toast.error('No se pudo cargar la lista de empresas.');
      }
    };
    fetchEmpresas();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let formattedVal = value;
    if (name ==='rut'){
      formattedVal = formatRut(value);
    }else if (name === 'telefono'){
      formattedVal = formatPhone(value);
    }
    setFormData({
      ...formData,
      [name]: formattedVal,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nombre || !formData.email || !formData.password || !formData.rut || !formData.sexo) {
      toast.error('Por favor completa todos los campos obligatorios');
      return;
    }
    if (!validatePassword(formData.password)) {
      toast.error('La contraseña debe ser al menos 8 caracteres, incluir una mayúscula y un número');
      return;
    }

    const payload = { 
      ...formData,
      rut: formData.rut.replace(/[^0-9kK]/g, '').toUpperCase() 
    };

    // Convertir strings vacíos en null
    Object.keys(payload).forEach(key => {
      if (payload[key] === "") {
        payload[key] = null;
      }
    });

    try {
      await postPatient(payload); // api.js
      toast.success('Paciente creado exitosamente.');
      navigate('/pacientes');
    } catch (error) {
      console.error('Error al crear paciente:', error.response?.data || error);

      if (error.response?.status === 409) {
        // Conflicto de unicidad (email o rut)
        const details = error.response?.data?.details;
        if (details) {
          const msgs = Object.entries(details).map(([field, msg]) => `${field}: ${msg}`);
          toast.error(<div>Conflicto de unicidad:{msgs.map((m, i) => <div key={i}>{m}</div>)}</div>);
        } else {
          toast.error("Conflicto: RUT o email ya registrados.");
        }
      } else if (error.response?.status === 422) {
        // Errores de validación de Marshmallow
        const validationErrors = error.response?.data?.errors?.json || error.response?.data?.details;
        if (validationErrors) {
          const msgs = Object.entries(validationErrors).map(([field, errs]) => {
            const label = field === 'rut' ? 'RUT' : field;
            const errorMessage = Array.isArray(errs) ? errs.join(', ') : errs;
            return `${label}: ${errorMessage}`;
          });
          toast.error(<div>Errores de validación:{msgs.map((m, i) => <div key={i}>{m}</div>)}</div>);
        } else {
          toast.error("Error de validación en los datos.");
        }
      } else {
        toast.error("Error inesperado al crear paciente.");
      }
    }
  };


  return (
    <div>
      <div className="content-wrapper">
        <h1>Crear Paciente</h1>
        <div className="container">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Nombre <span className='required-text' >*Obligatorio</span></label>
              <input
                type="text"
                name="nombre"
                value={formData.nombre}
                onChange={handleInputChange}
                className="form-control"
                required
              />
            </div>
            <div className="form-group">
              <label>Apellido Paterno</label>
              <input
                type="text"
                name="apellido_p"
                value={formData.apellido_p}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>Apellido Materno</label>
              <input
                type="text"
                name="apellido_m"
                value={formData.apellido_m}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>Email<span className='required-text' >*Obligatorio</span></label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <PasswordInput
              label="Contraseña"
              value={formData.password}
              onChange={handleInputChange}
            />
            <div className="form-group">
              <label>RUT <span className='required-text' >*Obligatorio</span></label>
              <input
                type="text"
                name="rut"
                value={formData.rut}
                onChange={handleInputChange}
                className="form-control"
                placeholder="Ej: 12.345.678-5"
                maxLength="12"
                required
              />
            </div>
            <div className="form-row"> 
              <div className="form-group">
                <label>Sexo<span className='required-text'>*Obligatorio</span></label>
                <select
                  name="sexo"
                  value={formData.sexo}
                  onChange={handleInputChange}
                  className="form-control"
                  required
                >
                  <option value="">Seleccione sexo</option>
                  <option value="femenino">Femenino</option>
                  <option value="masculino">Masculino</option>
                </select>
              </div>

              <div className="form-group">
                <label>Identidad de Género</label>
                <select
                  name="genero"
                  value={formData.genero}
                  onChange={handleInputChange}
                  className="form-control"
                >
                  <option value="">Seleccione género</option>
                  <option value="mujer">Mujer</option>
                  <option value="hombre">Hombre</option>
                  <option value="no binario">No binario</option>
                  <option value="no especificado">No especificado</option>
                </select>
              </div>
            </div>
            
            <div className="form-group">
              <label>Fecha de Nacimiento<span className='required-text' >*Obligatorio</span></label>
              <input
                type="date"
                name="fecha_nac"
                value={formData.fecha_nac}
                onChange={handleInputChange}
                className="form-control"
                required
              />
            </div>
            <div className="form-group">
              <label>Dirección</label>
              <input
                type="text"
                name="direccion"
                value={formData.direccion}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>Teléfono</label>
              <div className="phone-input-group" >
                <span className="phone-prefix">+56</span>
                <input
                type="tel"
                name="telefono"
                value={formData.telefono}
                onChange={handleInputChange}
                maxLength='9'
                placeholder='Ej: 912345678'
                size={15}
                className="phone-input-field"
              />
              </div>
            </div>
            <div className="form-group">
              <label>Empresa</label>
              <select
                name="id_empresa"
                value={formData.id_empresa}
                onChange={handleInputChange}
                className="form-control"
              >
                <option value=''>Seleccione una empresa</option>
                {empresas.map((empresa) => (
                  <option key={empresa.id_usuario} value={empresa.id_usuario}>
                    {empresa.nombre_legal}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <button type="submit" className="btn btn-create">
                Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CrearPaciente;